// Shared version info for table clients and servers
export const TABLE_APP_VERSION = 0.15;
export const TABLE_CLIENT_VERSION_EVENT = 'CLIENT_VERSION';
